import _ from 'lodash'
import config from 'scoreboard/components/config'

/**
 * Returns whether paste is allowed on the given node according to business
 * rules for the particular domain object being pasted.  Note rules about
 * not moving an object inside its own subtree are always enforced.  If
 * moving to a new organization, parent will be null.  The most common rules
 * are for dashboards, documents and reports so we'll implement those here.
 * @param node the node to be pasted
 * @param parent the new parent for the node (null if pasting to a top-level org)
 * @param emptyOrg true if the org is empty
 * @param mode either 'copy' or 'move'
 * @param org the org the destination paste occurs in
 * @param sourceOrg the org the source object comes from
 */
function defaultPasteAllowed(node, parent, emptyOrg, mode, org, sourceOrg) {
	if (globalPreventRules.apply(this, arguments)) {
		return false
	}

	// replicated structure cannot be modified
	if ((parent && !_.isNil(parent.syncId)) || !_.isNil(node.syncId)) {
		return false
	}

	return !parent || parent.type === 'folder'
}

/**
 * Defines rules that apply globally regardless of node (domain object) type.  Returns true
 * if the action should be prevented
 *
 * @param node the node to be pasted
 * @param parent the new parent for the node (null if pasting to a top-level org)
 * @param emptyOrg true if the org is empty
 * @param mode either 'copy' or 'move'
 * @param org the org the destination paste occurs in
 * @param sourceOrg the org the source object comes from
 */
function globalPreventRules(node, parent, emptyOrg, mode, org, sourceOrg) {
	//separating out rep concern from a function used to apply global prevent rules
	return testMixingReplication(org, sourceOrg) != null
}

/**
 * Returns error code if the target and source org differ in their replication
 * settings
 *
 * @param targetOrg the org the destination paste occurs in
 * @param sourceOrg the org the source object comes from
 * @return {String} error code if mixing rep, else null
 */
function testMixingReplication(targetOrg, sourceOrg, domainType) {
	//#34772 non-replicated content should be allowed to move regardless of org rep status
	if (!domainTypeUsesReplication(domainType)) {
		return null
	}

	//#21955 never allow mixed-replicated orgs to be the destination of anything
	if ((config.replicationInputEnabled || config.replicationOutputEnabled) &&
		_.result(targetOrg, 'replicated', true) != _.result(sourceOrg, 'replicated', true)) {
		return _.result(targetOrg, 'replicated', true) ? 'common.replication.sourceOrgNotReplicated' : 'common.replication.targetOrgNotReplicated'
	}
	return null
}

/**
 * Returns true if the domain type uses replication
 */
function domainTypeUsesReplication(domainType) {
	if (domainType == 'file' || domainType == 'dataset' || domainType == 'briefing'
		|| domainType == 'form') {
		return false
	}
	return true
}

export default defaultPasteAllowed
export { globalPreventRules }
export { testMixingReplication }
export { domainTypeUsesReplication }

defaultPasteAllowed.__filename__ = 'components/paste/default-paste-allowed.js'
